import Link from "@material-ui/core/Link";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Typography from "@material-ui/core/Typography";
import { FC, Fragment } from "react";
import { NavLink } from "react-router-dom";
import { BRAND_NAME, ROUTES, WORDPRESS_URL,ESHOP_URL } from "../../constants";
import { i18n } from "../../translations/i18n";
import { useTranslation } from "react-i18next";
import { fixUrlLanguage } from "@utils/changeLanguage";

interface ILink {
    route: string;
    title: string;
}

const links: ILink[] = [
    {
        route: WORDPRESS_URL + fixUrlLanguage(ROUTES.WORDPRESS_HOME_URL_EN) ?? "",
        title: i18n.t("header:home"),
    },
    {
        route: ESHOP_URL + fixUrlLanguage(ROUTES.ESHOP_URL_EN) ?? "",
        title: i18n.t("header:ourPlan"),
    },
    {
        route: WORDPRESS_URL + fixUrlLanguage(ROUTES.WORDPRESS_ABOUT_URL_EN) ?? "",
        title: i18n.t("header:about", { brand: BRAND_NAME }),
    },
    {
        route: WORDPRESS_URL + fixUrlLanguage(ROUTES.WORDPRESS_HELP_URL_EN) ?? "",
        title: i18n.t("header:helpSupport"),
    },
];

const navigationLink = (link: ILink) => (
    <Typography key={link.title} variant="subtitle2">
        {link.route === window.location.origin ? (
            <NavLink exact to="/">
                {link.title}
            </NavLink>
        ) : (
            <Link href={link.route} underline="none">
                {link.title}
            </Link>
        )}
    </Typography>
);

// eslint-disable-next-line react/jsx-no-useless-fragment
export const NavigationDesktop = () => <Fragment>{links.map((link) => navigationLink(link))}</Fragment>;

export const NavigationMobile: FC = () => {
    const { t } = useTranslation("header");

    return (
        <List disablePadding>
            {links.map((link) => (
                <ListItem button className="menu-list__item" divider key={link.title}>
                    {navigationLink(link)}
                </ListItem>
            ))}

            <ListItem button className="menu-list__item" divider>
                <Typography>
                    <Link href={fixUrlLanguage(ROUTES.MYACCOUNT_URL_EN)}>{t("myAccount", { brand: BRAND_NAME })}</Link>
                </Typography>
            </ListItem>
        </List>
    );
};
